import Plugin from '../core/Plugin';
import { PlayerEvent } from './../PlayerEvents';
import log from 'loglevel';

/**
 * 画中画插件
 *
 * @export
 * @class PlaybackRate
 * @extends {Plugin}
 */
export default class PictureInPicture extends Plugin {
  constructor() {
    super();
  }

  init() {
    this.videoDOM = this.player.getVideo();
    this.player.requestPictureInPicture = this.requestPictureInPicture.bind(this);
    this.player.exitPictureInPicture = this.exitPictureInPicture.bind(this);

    // 进入画中画事件
    this.videoDOM.addEventListener('enterpictureinpicture', event => {
      log.info('视频已进入Picture-in-Picture模式');
      this.player.emit2All(PlayerEvent.ENTER_PICTURE_IN_PICTURE, event);
    });

    // 退出画中画模式
    this.videoDOM.addEventListener('leavepictureinpicture', event => {
      log.info('视频已退出Picture-in-Picture模式');
      this.player.emit2All(PlayerEvent.EXIT_PICTURE_IN_PICTURE, event);
    });
  }

  // 进入画中画
  requestPictureInPicture(opt) {
    // 是否返回Promise
    let isByPromise = !(typeof opt?.success === 'function' || typeof opt?.fail === 'function');
    if (!document.pictureInPictureEnabled) {
      // 不支持画中画
      const res = { code: 611040, message: '不支持画中画' };
      return isByPromise ? Promise.reject(res) : opt?.fail?.(res);
    }

    if (this.videoDOM === document.pictureInPictureElement) {
      // 已经是画中画模式
      const res = { code: 611041, message: '已经是画中画模式' };
      return isByPromise ? Promise.reject(res) : opt?.fail?.(res);
    }

    if (isByPromise) {
      return this.videoDOM.requestPictureInPicture();
    } else {
      this.videoDOM.requestPictureInPicture().then(opt?.success).catch(opt?.fail);
    }
  }

  // 退出画中画
  exitPictureInPicture(opt) {
    // 是否返回Promise
    let isByPromise = !(typeof opt?.success === 'function' || typeof opt?.fail === 'function');

    // todo： video.disablePictureInPicture，参考https://w3c.github.io/picture-in-picture/#disable-pip
    if (!document.pictureInPictureEnabled) {
      // 不支持画中画
      const res = { code: 611040, message: '不支持画中画' };
      return isByPromise ? Promise.reject(res) : opt?.fail?.(res);
    }
    if (this.videoDOM !== document.pictureInPictureElement) {
      // 不是画中画模式，不需要退出
      const res = { code: 611042, message: '不是画中画模式' };
      return isByPromise ? Promise.reject(res) : opt?.fail?.(res);
    }

    if (isByPromise) {
      return document.exitPictureInPicture();
    } else {
      document.exitPictureInPicture().then(opt?.success).catch(opt?.fail);
    }
  }

  static get type() {
    return 'plugin_pictureinpicture';
  }
}
